import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "path-2-inside-1_214_41050",
  fill: "white"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.6665 10C7.45737 10 5.6665 11.7909 5.6665 14V19H43.6665V14C43.6665 11.7909 41.8756 10 39.6665 10H9.6665ZM12.1665 16C12.9949 16 13.6665 15.3284 13.6665 14.5C13.6665 13.6716 12.9949 13 12.1665 13C11.3381 13 10.6665 13.6716 10.6665 14.5C10.6665 15.3284 11.3381 16 12.1665 16ZM17.6665 14.5C17.6665 15.3284 16.9949 16 16.1665 16C15.3381 16 14.6665 15.3284 14.6665 14.5C14.6665 13.6716 15.3381 13 16.1665 13C16.9949 13 17.6665 13.6716 17.6665 14.5ZM20.1665 16C20.9949 16 21.6665 15.3284 21.6665 14.5C21.6665 13.6716 20.9949 13 20.1665 13C19.3381 13 18.6665 13.6716 18.6665 14.5C18.6665 15.3284 19.3381 16 20.1665 16Z"
  })
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.6665 10C7.45737 10 5.6665 11.7909 5.6665 14V19H43.6665V14C43.6665 11.7909 41.8756 10 39.6665 10H9.6665ZM12.1665 16C12.9949 16 13.6665 15.3284 13.6665 14.5C13.6665 13.6716 12.9949 13 12.1665 13C11.3381 13 10.6665 13.6716 10.6665 14.5C10.6665 15.3284 11.3381 16 12.1665 16ZM17.6665 14.5C17.6665 15.3284 16.9949 16 16.1665 16C15.3381 16 14.6665 15.3284 14.6665 14.5C14.6665 13.6716 15.3381 13 16.1665 13C16.9949 13 17.6665 13.6716 17.6665 14.5ZM20.1665 16C20.9949 16 21.6665 15.3284 21.6665 14.5C21.6665 13.6716 20.9949 13 20.1665 13C19.3381 13 18.6665 13.6716 18.6665 14.5C18.6665 15.3284 19.3381 16 20.1665 16Z",
  fill: "#475467"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.6665 19H3.6665V21H5.6665V19ZM43.6665 19V21H45.6665V19H43.6665ZM7.6665 14C7.6665 12.8954 8.56193 12 9.6665 12V8C6.3528 8 3.6665 10.6863 3.6665 14H7.6665ZM7.6665 19V14H3.6665V19H7.6665ZM43.6665 17H5.6665V21H43.6665V17ZM41.6665 14V19H45.6665V14H41.6665ZM39.6665 12C40.7711 12 41.6665 12.8954 41.6665 14H45.6665C45.6665 10.6863 42.9802 8 39.6665 8V12ZM9.6665 12H39.6665V8H9.6665V12ZM11.6665 14.5C11.6665 14.2239 11.8904 14 12.1665 14V18C14.0995 18 15.6665 16.433 15.6665 14.5H11.6665ZM12.1665 15C11.8904 15 11.6665 14.7761 11.6665 14.5H15.6665C15.6665 12.567 14.0995 11 12.1665 11V15ZM12.6665 14.5C12.6665 14.7761 12.4426 15 12.1665 15V11C10.2335 11 8.6665 12.567 8.6665 14.5H12.6665ZM12.1665 14C12.4426 14 12.6665 14.2239 12.6665 14.5H8.6665C8.6665 16.433 10.2335 18 12.1665 18V14ZM16.1665 18C18.0995 18 19.6665 16.433 19.6665 14.5H15.6665C15.6665 14.2239 15.8904 14 16.1665 14V18ZM12.6665 14.5C12.6665 16.433 14.2335 18 16.1665 18V14C16.4426 14 16.6665 14.2239 16.6665 14.5H12.6665ZM16.1665 11C14.2335 11 12.6665 12.567 12.6665 14.5H16.6665C16.6665 14.7761 16.4426 15 16.1665 15V11ZM19.6665 14.5C19.6665 12.567 18.0995 11 16.1665 11V15C15.8904 15 15.6665 14.7761 15.6665 14.5H19.6665ZM19.6665 14.5C19.6665 14.2239 19.8904 14 20.1665 14V18C22.0995 18 23.6665 16.433 23.6665 14.5H19.6665ZM20.1665 15C19.8904 15 19.6665 14.7761 19.6665 14.5H23.6665C23.6665 12.567 22.0995 11 20.1665 11V15ZM20.6665 14.5C20.6665 14.7761 20.4426 15 20.1665 15V11C18.2335 11 16.6665 12.567 16.6665 14.5H20.6665ZM20.1665 14C20.4426 14 20.6665 14.2239 20.6665 14.5H16.6665C16.6665 16.433 18.2335 18 20.1665 18V14Z",
  fill: "#475467",
  mask: "url(#path-2-inside-1_214_41050)"
}, null, -1 /* HOISTED */)
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeIcon',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "49",
    height: "48",
    viewBox: "0 0 49 48",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("path", {
      d: "M6.6665 18H42.6665V34C42.6665 35.6569 41.3234 37 39.6665 37H9.6665C8.00965 37 6.6665 35.6569 6.6665 34V18Z",
      stroke: __props.strokeColor,
      "stroke-width": "2"
    }, null, 8 /* PROPS */, _hoisted_5),
    _createElementVNode("path", {
      d: "M28.9742 30.8L32.6665 27.5L28.9742 24.2M20.3588 24.2L16.6665 27.5L20.3588 30.8M25.8973 22L23.4357 33",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_6)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})